import { Phone, MessageCircle, Send } from "lucide-react";
import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { trackEvent } from "@/lib/tracking";

export default function MobileStickyCTA() {
    const { t } = useI18n();
    const [s, setS] = useState({ whatsapp_number: "4915231656312", phone_number: "+4915231656312", whatsapp_prefill: "" });

    useEffect(() => {
        api.get("/settings/public").then(({ data }) => setS(data)).catch(() => {});
    }, []);

    const wa = `https://wa.me/${(s.whatsapp_number || "4915231656312").replace(/\D/g, "")}?text=${encodeURIComponent(s.whatsapp_prefill || "Hallo BA Media Performance, ich interessiere mich für ein Lead-Funnel-System für mein Unternehmen.")}`;
    const tel = `tel:${(s.phone_number || "+4915231656312").replace(/\s/g, "")}`;

    return (
        <div className="md:hidden fixed bottom-0 inset-x-0 z-40 px-3 pb-3 pt-2 pointer-events-none" data-testid="mobile-sticky-cta">
            <div className="pointer-events-auto bm-glass-light shadow-[0_-12px_40px_rgba(15,23,42,0.12)] rounded-2xl p-2 flex items-stretch gap-2">
                <a
                    href={wa}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => trackEvent("whatsapp_click", { position: "sticky" })}
                    data-testid="sticky-whatsapp-btn"
                    className="flex-1 inline-flex items-center justify-center gap-2 py-3 rounded-xl bg-[#047857] text-white font-semibold text-sm shadow-[0_8px_22px_rgba(4,120,87,0.35)] active:scale-[0.98] transition"
                >
                    <MessageCircle className="size-4" /> {t("sticky.whatsapp")}
                </a>
                <a
                    href={tel}
                    onClick={() => trackEvent("call_click", { position: "sticky" })}
                    data-testid="sticky-call-btn"
                    className="flex-1 inline-flex items-center justify-center gap-2 py-3 rounded-xl bg-[#0F172A] text-white font-semibold text-sm active:scale-[0.98] transition"
                >
                    <Phone className="size-4" /> {t("sticky.call")}
                </a>
                <a
                    href="/#kontakt"
                    onClick={() => trackEvent("cta_click", { position: "sticky_analyse" })}
                    data-testid="sticky-analyse-btn"
                    className="flex-1 inline-flex items-center justify-center gap-2 py-3 rounded-xl border border-[#0F172A]/10 bg-white text-[#0F172A] font-semibold text-sm active:scale-[0.98] transition"
                >
                    <Send className="size-4" /> {t("sticky.analyse")}
                </a>
            </div>
        </div>
    );
}
